import { Injectable } from "@angular/core";
import { UsersNewsletterRegistered } from "@core/interfaces/usersNewsletterRegistered";
import { ApiServiceHolder } from "@core/utils/api-service-holder";
import { Observable } from 'rxjs';
import { ApiService } from "./api.service";

@Injectable({
    providedIn: 'root'
  })
  export class UsersNewsletterRegisteredService {
  
    constructor(private _api: ApiService) { }
    
    getAll(): Observable<UsersNewsletterRegistered[]>{
      return this._api.request(ApiServiceHolder.usersNewsletterRegistered.getAll());
    }

    insert(email: UsersNewsletterRegistered) {
      return this._api.request(ApiServiceHolder.usersNewsletterRegistered.Insert(email));
    }
  }
  